import * as React from "react";
import { useEffect, useMemo, useState } from "react";

import { api } from "../api";
import { RLink } from "../DesignSystem/RLink";
import { TestIds } from "../testIds";

const allMsgs = [
  "made with ♪",
  "a healthy part of any balanced musical diet",
  "just don't get too salty!",
  "because the fastest way to improve is 1) rapid feedback and 2) mentorship!",
  "the tastiest compo around",
  "remember to be kind <small><u><em>or else i'll ban you</em></u></small>",
  "the tastiest compo around",
  "because you deserve more feedback than a like from 'BUY NEW SOUNDCLOUD FOLLOWERS TODAY'",
  "building a friendly community, one ban at a time",
  "we love you!~ ",
  "all genres welcome ~ ",
  "i will hack the site to give chiptune entries extra points ",
  "this message also brought to you by random number generation ",
  "remember to be friendly! ",
  "disregard the last message you saw here ",
  "because salsa compo was taken",
  "i will personally mail a bag of chips to the first person to score a perfect 5 in any category ",
  "let's make some music!",
  "help im trapped in a motivational message factory",
  "named after the things you eat",
  "i like turtles",
  "hemlo yes i am the do durgs",
  "woo woo",
  "yay",
];

export function getSpecialStupidSaying(): JSX.Element {
  const msgsJSX = [
    <span className="text-gray-400" key="be-kind">
      remember to be kind{" "}
      <small>
        <u>
          <em>or else i'll ban you</em>
        </u>
      </small>
    </span>,
    <span className="text-gray-400" key="delete-site">
      congrats, you found the secret DELETE THE SITE button! please don't press
      it.{" "}
      <button
        className="inline h-0 w-[100px] bg-transparent p-[5px] text-[12px] font-light normal-case tracking-[0px] text-white"
        onClick={() => document.write("You deleted the sight. Nice work!")}
      >
        delete the sight
      </button>
    </span>,
  ];

  return msgsJSX[Math.floor(Math.random() * msgsJSX.length)];
}

export function getStupidSayingNoFormatting(): string {
  return (
    "chips compo :: " + allMsgs[Math.floor(Math.random() * allMsgs.length)]
  );
}

export const Footer = (): JSX.Element => {
  const [hasServerMsg] = useState(() => Math.random() > 0.1);
  const [message, setMessage] = useState<string>();

  const fallbackMessage = useMemo(getSpecialStupidSaying, []);

  useEffect(() => {
    if (!hasServerMsg) {
      return;
    }

    let isMounted = true;
    const fetchMessage = async () => {
      const [{ msg }] = await api.get(`/api/saying`);

      if (isMounted) {
        setMessage(msg);
      }
    };

    fetchMessage();

    return () => {
      isMounted = false;
    };
  }, [hasServerMsg]);

  return (
    <div
      className="border-t border-slate-300 bg-slate-200 px-[5%] py-12 text-center dark:border-slate-700 dark:bg-slate-950"
      data-test="site-footer"
      data-testid={TestIds.SiteFooter}
    >
      <div className="mx-auto flex max-w-4xl flex-col text-[12px]">
        <div className="break-words text-slate-700 dark:text-slate-200">
          chips compo ::{" "}
          {hasServerMsg ? (message ?? fallbackMessage) : fallbackMessage}
        </div>

        <div className="text-slate-500 dark:text-slate-400">
          <RLink to="/explain-everything">Rules</RLink>
          <span className="mx-2">·</span>
          <RLink to="/compo/2/theme">Suggest a feature / Report a bug</RLink>
          <span className="mx-2">·</span>
          <RLink to="http://www.twitter.com/chipscompo">
            <i className="fa fa-twitter"></i>
          </RLink>
          <span className="mx-2">·</span>
          <RLink to="https://www.facebook.com/ChipsCompo/">
            <i className="fa fa-facebook"></i>
          </RLink>
        </div>
      </div>
    </div>
  );
};
